import { Toast } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';

import { AuthService } from './core/services/auth.service';
import { DeviceSessionService } from './core/services/device-session.service';
import { LoadingService } from './shared/services/loading.service';
import { NotificationService } from './core/services/notification.service';
import { VersioningService } from './core/services/versioning/versioning.service';
import { UpdateDialogComponent } from './shared/components/update-dialog/update-dialog.component';
import { AppLoadingOverlayComponent } from './shared/components/loading-overlay/loading-overlay.component';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, Toast, ConfirmDialog, AppLoadingOverlayComponent, UpdateDialogComponent],
	providers: [NotificationService, ConfirmationService],
	template: `
		<p-toast position="top-center" styleClass="hidden sm:block"></p-toast>
		<p-toast position="top-center" styleClass="block sm:hidden !w-[95%]"></p-toast>
		<p-confirmdialog position="center" styleClass="w-[95%] max-w-2xl sm:w-lg"></p-confirmdialog>
		<app-loading-overlay [(visible)]="spinner.isLoading" />
		<app-update-dialog [(visible)]="versioningService.versionState().updateAvailable" />
		<router-outlet></router-outlet>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
	private readonly router = inject(Router);
	private readonly authService = inject(AuthService);
	private readonly deviceSessionService = inject(DeviceSessionService);
	public readonly versioningService = inject(VersioningService);
	public readonly spinner = inject(LoadingService);

	constructor() {
		this.router.events.subscribe(event => {
			if (event instanceof RouteConfigLoadStart) {
				this.spinner.show();
			}
			if (event instanceof RouteConfigLoadEnd) {
				this.spinner.hide();
			}
		});
	}

	ngOnInit(): void {
		this.authService.handleTokenFromUrl();
		this.authService.cleanUpUrl();
		this.deviceSessionService.restoreCachedDevicePolicyRules();
		if (this.authService.isAuthenticated()) {
			this.authService.refreshDeviceSessionFromApi();
		}
		this.versioningService.initialize();
	}
}
